// settingsDefaults.js
// Single source of truth for default playback settings, shared by the authenticated player
// (ViewPost.vue), the public player (PostView.vue), and the Settings form (SettingsPage.vue),
// so the three can never disagree. Change the canon here and only here.
//
// Canon (Jul 2026): continuous + full caption audio. For a session with no stored preference
// (new accounts, and the anonymous public route) the narration plays over the video instead of
// the video pausing into silence — the intended experience for oral/unwritten-language content.
// Saved preferences always win over these. In continuous mode captionVolume 1.0 ducks the video
// to 0 via the standing coupling (video volume = 1.0 - captionVolume).
//
// Field notes:
//   playbackStyle           'continuous' = audio and video play together (video ducks under the
//                           narration); 'pauseplay' = video pauses while each narration segment plays.
//   playbackStyleSameStart  segment-overlap handling (UI label: "Skip Overlap"). true = skip the
//                           overlapped segment; false = chop (cut it off) and play the next. Legacy
//                           field name — it is the segment-overlap toggle, not a start-alignment flag.
//   captionVolume           narration volume, 0-1. captionAudio (boolean) is its on/off proxy.

// String/numeric form — used by the players (ViewPost.vue, PostView.vue).
export const CANONICAL_DEFAULTS = {
    showCaptions: true,
    playbackStyle: 'continuous',
    playbackStyleSameStart: true, // skip overlapping segments
    captionVolume: 1.0,
    playbackRate: 1.0,
};

// Boolean form — used by SettingsPage.vue, whose v-switch models are booleans. Derived from
// CANONICAL_DEFAULTS so the two representations stay in lockstep.
export const SETTINGS_FORM_DEFAULTS = {
    showCaptions: CANONICAL_DEFAULTS.showCaptions,
    playbackStyle: CANONICAL_DEFAULTS.playbackStyle === 'continuous', // true = continuous
    playbackStyleSameStart: CANONICAL_DEFAULTS.playbackStyleSameStart, // true = skip overlap
    captionAudio: CANONICAL_DEFAULTS.captionVolume > 0, // true = narration audio on
};